import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { AuthUserContext, withAuthorization } from '../Session';
import * as ROUTES from "../../constants/routes";
import {employeeSort} from "../../utils";

class StaffPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            staff: [],
            search: ''
        };
    }

    componentDidMount() {
        this.setState({ loading: true });

        this.props.firebase.staff().on('value', snapshot => {
            const staffObject = snapshot.val() ? snapshot.val() : [];

            const staffList = Object.keys(staffObject).map(key => ({
                ...staffObject[key],
                uid: key,
            }));

            staffList.sort(employeeSort);

            this.setState({
                staff: staffList,
                loading: false,
            });
        });
    }

    componentWillUnmount() {
        this.props.firebase.staff().off();
    }

    deleteStaff = (uid) => {
        this.props.firebase
            .employee(uid).remove()
            .then(() => {

            })
            .catch(error => {
                this.setState({ error });
            });
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { staff, loading, search } = this.state;

        return (
            <AuthUserContext.Consumer>
                {() => (
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="row no-gutters align-items-center justify-content-between mb-5">
                                    <span className="h1 mb-3 mb-md-0">Staff</span>
                                    <div className="form-group mb-3 mb-md-0">
                                        <input
                                            className="form-control"
                                            name="search"
                                            value={search}
                                            onChange={this.onChange}
                                            type="text"
                                            placeholder="Search employee"
                                        />
                                    </div>
                                    <Link to={ROUTES.STAFF_ADD}>
                                        <button className="btn btn-outline-primary">Add staff</button>

                                    </Link>
                                </div>
                            </div>
                        </div>

                        {loading && <div>Loading ...</div>}
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <StaffList staff={staff.filter(employee => {return [employee.firstName, employee.lastName].join(' ').toLowerCase().includes(search.toLowerCase())})} deleteStaff={this.deleteStaff}/>
                            </div>
                        </div>

                    </div>
                )}
            </AuthUserContext.Consumer>
        );
    }
}

const StaffList = ({ staff, deleteStaff }) => (
    <table className="table">
        <thead className="thead-dark">
            <tr>
                <th>Full name</th>
                <th>Action</th>
            </tr>
        </thead>
        <tbody>
        {
            staff.length > 0 ? (
                staff.map(employee => (
                        <tr key={employee.uid}>
                            <td><Link to={'/admin/staff/' + employee.uid}>{employee.firstName} {employee.lastName}</Link></td>
                            <td><button className="btn btn-danger" onClick={() => deleteStaff(employee.uid)}>Delete</button></td>
                        </tr>
                    )
                )
            ) : (
                <tr>
                    <td className="text-center py-4" colSpan="2">Staff list is empty</td>
                </tr>
            )
        }
        </tbody>
    </table>
);


const condition = authUser => !!authUser;

export default withAuthorization(condition)(StaffPage);